import React, { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Input, Button, Form } from 'antd';
import { actions as appointmentActions } from 'store/appointment';
import * as _ from 'lodash';
import StoreState from 'models/store';
import { formRules } from 'helpers/formUtils';
import AppointmentCard from '../../AppointmentCard/AppointmentCard';

const Beer: FC<any> = props => {
  const { dataProps, onGetAppointmentDetail, isEditAvailability } = props;
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isAdd, setIsAdd] = useState<boolean>(false);
  const [i, setI] = useState<any>();
  const originTime = new Date();
  const appointmentReducer = useSelector(
    (state: StoreState) => state.appointment,
  );
  const [isSubmit, setIsSubmit] = useState(false);

  const arrAlcohol = dataProps?.detail?.encounters[0]?.obs?.filter(item =>
    item?.display?.includes('ALCOHOL'),
  );
  const handleEdit = _.debounce(key => {
    setIsEdit(true);
    setI(key);
  }, 50);

  const handleCancel = _.debounce(key => {
    setIsEdit(false);
    setI(key);
  }, 50);

  // const handleSave = _.debounce(key => {
  //   setIsEdit(false);
  //   setI(key);
  // }, 50);
  const onFinish = values => {
    setIsSubmit(true);
    const { value } = values;
    const paramsCreateAlcohol = {
      value,
      concept: '7240bd9c-cef3-4fef-9188-a135f0b4ad2a',
      obsDatetime: originTime?.toISOString(),
      person: dataProps?.detail?.uuidPerson,
      encounter: dataProps?.detail?.encounters[0]?.uuid,
    };
    dispatch(appointmentActions.handleCreateAlcohol(paramsCreateAlcohol));
    setIsEdit(false);
  };
  const { initValues } = props;

  const onEdit = values => {
    const { beer } = values;
    const uuidAlcohol = arrAlcohol[i]?.uuid;
    const paramsEditAlcohol = {
      value: beer,
    };
    dispatch(
      appointmentActions.handleEditAlcohol({
        uuidAlcohol,
        paramsEditAlcohol,
        onSucceeded: onGetAppointmentDetail,
      }),
    );
    setIsEdit(false);
  };

  useEffect(() => {
    if (isSubmit === true && appointmentReducer?.isAddAlcohol === true) {
      setIsAdd(false);
    }
  }, [appointmentReducer?.isAddAlcohol]);

  return (
    <div className="drug-in-use">
      {initValues?.length > 0 ? (
        <AppointmentCard title="Rượu bia">
          {initValues?.map((item, key) => {
            return (
              <Row className="row-1" key={key}>
                <Col xs={24}>
                  <div className="anamnesis-section">
                    <Form onFinish={onEdit}>
                      <div className="anamnesis-section__title">
                        <div>
                          <span> </span>
                        </div>
                        <div className="btn-edit">
                          {isEditAvailability &&
                            (isEdit && key === i ? (
                              <>
                                <Button
                                  size="middle"
                                  onClick={() => handleCancel(key)}
                                >
                                  Hủy
                                </Button>{' '}
                                <Button size="middle" htmlType="submit">
                                  Lưu
                                </Button>
                              </>
                            ) : (
                              <Button
                                onClick={() => handleEdit(key)}
                                size="middle"
                              >
                                Sửa
                              </Button>
                            ))}
                        </div>
                      </div>
                      <div className="anamnesis-section__content">
                        <div className="anamnesis-section__content_inside">
                          {isEdit && key === i ? (
                            <Form.Item
                              name="beer"
                              preserve={false}
                              rules={formRules}
                              initialValue={item}
                            >
                              <Input />
                            </Form.Item>
                          ) : (
                            <span className="text-have-color-#555555">
                              {item}
                            </span>
                          )}
                        </div>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            );
          })}
        </AppointmentCard>
      ) : (
        <Row className="row-1">
          <Col xs={24}>
            <div className="anamnesis-section">
              <div className="anamnesis-section__title">
                <div>
                  <span>Rượu bia</span>
                </div>
              </div>
              <div className="no-content">
                <span className="no-content__text">Chưa có thông tin</span>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {isEditAvailability && (
        <div className="anamnesis-add-container">
          {isAdd ? (
            <Form onFinish={onFinish}>
              <div className="anamnesis-input-add">
                <Form.Item name="value" rules={formRules}>
                  <Input
                    size="large"
                    placeholder="Thêm thông tin rượu bia"
                    ref={input => input && input.focus()}
                  />
                </Form.Item>
              </div>
              <div className="anamnesis-action-add">
                <div className="btn-ok">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={appointmentReducer?.isLoadingAddAlcohol}
                  >
                    Lưu
                  </Button>
                </div>
                <div className="btn-cancel">
                  <a
                    className="no-underline"
                    href="#"
                    onClick={() => setIsAdd(!isAdd)}
                  >
                    <span>Hủy</span>
                  </a>
                </div>
              </div>
            </Form>
          ) : (
            <div>
              <Button
                className="rounded-md"
                type="primary"
                onClick={() => setIsAdd(!isAdd)}
              >
                Thêm thông tin
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Beer;
